import React, { useRef } from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';
import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';

import AccountMenu from './AccountMenu';
import _UserButton from "AccountMenuButton-UserButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=UserButton";
import _ButtonProfilePic from "AccountMenuButton-ButtonProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=ButtonProfilePic";
import _ButtonNameAndCaret from "AccountMenuButton-ButtonNameAndCaret.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=ButtonNameAndCaret";
import _ButtonName from "AccountMenuButton-ButtonName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=ButtonName";
import _ButtonCaret from "AccountMenuButton-ButtonCaret.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=ButtonCaret";
import _MenuContainer from "AccountMenuButton-MenuContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenuButton.tsx?styleId=MenuContainer";


const UserButton = /*#__PURE__*/styled("button", null, {
  displayName: "UserButton",
  styles: _UserButton
});

const ButtonProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "ButtonProfilePic",
  styles: _ButtonProfilePic
});

const ButtonNameAndCaret = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonNameAndCaret",
  styles: _ButtonNameAndCaret
});

const ButtonName = /*#__PURE__*/styled("span", null, {
  displayName: "ButtonName",
  styles: _ButtonName
});

const ButtonCaret = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonCaret",
  styles: _ButtonCaret
});

const MenuContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MenuContainer",
  styles: _MenuContainer
});

type Props = {
  open: boolean;
  setOpen: (openness: boolean) => void;
};

const AccountMenuButton = ({ open, setOpen }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useOnClickOutside([buttonRef, menuRef], () => setOpen(false));

  return (
    <>
      <UserButton
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        aria-pressed={open}
      >
        {currentUser != null && (
          <ButtonProfilePic src={$image_url(currentUser.photo)} />
        )}
        <ButtonNameAndCaret>
          <ButtonName>{currentUser?.first_name}</ButtonName>
          <ButtonCaret>
            <Icon name="keyboard_arrow_down" />
          </ButtonCaret>
        </ButtonNameAndCaret>
      </UserButton>
      {open && (
        <MenuContainer ref={menuRef}>
          <AccountMenu />
        </MenuContainer>
      )}
    </>
  );
};

export default AccountMenuButton;
